import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountLedgerBankAccountComponent = ({ onInnerFormChange, selectedAccountLedgers }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="Account Holder Name"
                        name="AccountHolderName"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'BankAccount.AccountHolderName',
                                selectedAccountLedgers?.BankAccount
                            )
                        }}
                        type="text"
                        value={selectedAccountLedgers?.BankAccount?.AccountHolderName}
                    />
                    <InputContainer
                        label="Account Number"
                        name="AccountNumber"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'BankAccount.AccountNumber',
                                selectedAccountLedgers?.BankAccount
                            )
                        }}
                        type="text"
                        value={selectedAccountLedgers?.BankAccount?.AccountNumber}
                    />
                    <InputContainer
                        label="Bank Name"
                        name="BankName"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'BankAccount.BankName',
                                selectedAccountLedgers?.BankAccount
                            )
                        }}
                        type="text"
                        value={selectedAccountLedgers?.BankAccount?.BankName}
                    />
                    <InputContainer
                        label="Branch"
                        name="Branch"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'BankAccount.Branch',
                                selectedAccountLedgers?.BankAccount
                            )
                        }}
                        type="text"
                        value={selectedAccountLedgers?.BankAccount?.Branch}
                    />
                    <InputContainer
                        label="IFSC Code"
                        name="IFSCCode"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'BankAccount.IFSCCode',
                                selectedAccountLedgers?.BankAccount
                            )
                        }}
                        type="text"
                        value={selectedAccountLedgers?.BankAccount?.IFSCCode}
                    />
                    <InputContainer
                        label="Opening Balance"
                        name="OpeningBalance"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'BankAccount.OpeningBalance',
                                selectedAccountLedgers?.BankAccount
                            )
                        }}
                        type="number"
                        value={selectedAccountLedgers?.BankAccount?.OpeningBalance}
                    />
                </div>
            }
            expandedPanel="Bank Account"
            headerTitle="Bank Account"
        />
    </>
)

export default AccountLedgerBankAccountComponent;